export const API_MENU_FIELDS = [
    'menu.id',
    'menu.status',
    'menu.slug',
    'menu.translations',
    'menu.menu_type',
    'menu.parent',
    'menu.internal_link',
    'menu.show_sitemap',
    'menu.is_route',
    'menu.color_class',
    'menu.menu_icon',
    'menu.submenus'
];
export const API_PROJECT_LINK_MENU_FIELDS = [
    'project_link.id',
    'project_link.status',
    'project_link.slug',
    'project_link.translations',
    'project_link.internal_link'
];
